import React, { Fragment } from "react"

let addWidth = (title) => {
    let arr = ["CUST-DEPT", "STYLE NAME"]
    switch (title) {
        case "STYLE NAME":
            return "5%"
        case "CUST REF NO":
            return "1%"
        case "ITEM NO":
            return "1%"
        case "SIZE":
            return "1%"
        case "SAMPLE TYPE":
            return "1%"
        case "QTY":
            return "1%"
        default:
            return '2%'
    }
}
function Dispatch(props) {
    return (
        <Fragment>
                    <tr>
                        <td className="report-header text-left" width="1%">&nbsp;</td>
                        <td className="report-header text-left border" nowrap width="20%">CUSTOMER</td>
                        <td className="report-header text-left border" width="7%">DATE</td>
                        <td className="report-header text-left border" width="15%">AWB NO.</td>
                        <td className="report-header text-left border" width="15%">LOCATION</td>
                        <td className="report-header text-left border" width="15%">COURIER</td>
                        <td className="report-header text-left border" width="27%">&nbsp;</td>
                    </tr>
            {props.list !== undefined &&
                Array.isArray(props.list) &&
                props.list.length > 0 &&
                props.list.map((data, index) => {
                    return <Fragment>
                                <tr className="text-left" style={{ display: 'table-row', borderTop: "1px solid #ddeeff", borderBottom: `${index === props.list.length - 1 ? "1px solid #ddeeff" : "none"}` }}>
                                    <td width="1%" style={{ borderLeft: "1px solid #ddeeff", borderRight: "1px solid #ddeeff", borderTop: "1px solid #ddeeff", }}>
                                        <a href="javascript:;" className="font-weight-bold primary" onClick={() => props.displayData(index)}>{data.disable ? <b><i class="material-icons">unfold_less</i></b> : <b><i class="material-icons">unfold_more</i></b>}</a>
                                    </td>
                                    <td className="text-left" width="20%" style={{ borderLeft: "1px solid #ddeeff", borderRight: "1px solid #ddeeff" }} ><b>{data.customer}</b></td>
                                    <td className="text-left" width="7%" style={{ borderLeft: "1px solid #ddeeff", borderRight: "1px solid #ddeeff" }} ><b>{data.date}</b></td>
                                    <td className="text-left" width="15%" style={{ borderLeft: "1px solid #ddeeff", borderRight: "1px solid #ddeeff" }} ><b>{data.awbNumber}</b></td>
                                    <td className="text-left" width="15%" style={{ borderLeft: "1px solid #ddeeff", borderRight: "1px solid #ddeeff" }} ><b>{data.location}</b></td>
                                    <td className="text-left" width="15%" style={{ borderLeft: "1px solid #ddeeff", borderRight: "1px solid white" }} ><b>{data.courier}</b></td>
                                    <td className="text-left" width="27%" style={{ borderLeft: "1px solid #ddeeff" }} >&nbsp;</td>
                                </tr>

                        <table className={data.disable ? "" : 'd-none'} border="0" style={{ width: '80%' }}>
                            <tbody>
                                <tr style={{ display: 'table-row' }}>
                                    {["DEPT", "STYLE NO", "CUST REF NO", "ITEM NO", "STYLE NAME", "SAMPLE TYPE", "SIZE", "QTY","FABRIC", "COMMENTS"].map(ref =>
                                        <td style={{ wordWrap: 'break-word', borderTop: "1px solid white", borderRight: "1px solid white" }} width={addWidth(ref)} className="report-sub-header text-left border">{ref}</td>
                                    )}
                                </tr>
                                {data.data.map(ref => (
                                    <tr style={{ wordWrap: 'break-word' }}>
                                        {["DEPT", "STYLE NO", "CUST REF NO", "ITEM NO", "STYLE NAME", "SAMPLE TYPE", "SIZE", "QTY","FABRIC", "COMMENTS"].map(dat =>
                                            <td width={addWidth(ref)} className="text-left"><span className="wordwrap">{ref[dat]}</span></td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Fragment>

                })}
        </Fragment>

    )
}
export default Dispatch;


// WEBPACK FOOTER //
// ./src/components/Report/reports/dispatch.js